if (!customElements.get('subscription-modal-button')) {
  const purchaseOptionsModal = document.querySelector('.purchase-options-modal')
  customElements.define(
    'subscription-modal-button',
    class SubscriptionModalButton extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.initialize()
      }

      initialize() {
        this.timeout = setTimeout(() => {
          if (this.timeout) {
            clearTimeout(this.timeout);
            if (window.isOGInitialized) {
              this.submitButton = this.querySelector('#submit');
              this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
              this.submitButtonText = this.submitButton.querySelector('span');
              if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
              this.submitButton.classList.remove('hidden')
            } else {
              this.initialize()
            }
          }
        }, 200)
      }

      toggleSubscriptionSection(hideSubscriptionSection) {
        const subscriptionSections =
          purchaseOptionsModal.querySelectorAll('.subscription-box')
        subscriptionSections.forEach((subscriptionSection) => {
          if (hideSubscriptionSection === 'hide') {
            subscriptionSection.classList.add('hide')
          } else if (hideSubscriptionSection === 'show') {
            subscriptionSection.classList.remove('hide')
          }
        })
      }

      async onSubmitHandler(event) {
        event.preventDefault()

        // setup modal UI based on user settings
        purchaseOptionsModal.setAttribute(
          'data-product-id',
          this.submitButton.getAttribute('data-product-id'),
        )
        purchaseOptionsModal.setAttribute('data-product-sku', this.submitButton.getAttribute('data-product-sku'))
        purchaseOptionsModal.setAttribute('data-product-name', this.submitButton.getAttribute('data-product-name'))
        purchaseOptionsModal.setAttribute('data-product-category', this.submitButton.getAttribute('data-product-category'))
        purchaseOptionsModal.setAttribute(
          'data-product-variant-id',
          this.submitButton.getAttribute('data-product-variant-id'),
        )
        purchaseOptionsModal.setAttribute(
          'data-product-variant-name',
          this.submitButton.getAttribute('data-product-variant-name'),
        )
        purchaseOptionsModal.setAttribute(
          'data-product-variant-price',
          this.submitButton.getAttribute(
            'data-product-variant-price',
          ),
        )
        purchaseOptionsModal.querySelector('[name=id]').value = this.submitButton.getAttribute('data-product-variant-id');
        const numberOfSellingPlans = this.submitButton.getAttribute(
          'data-product-number-of-selling-plans',
        )
        let isNextBoxMessageState = 'hidden'

        if (window.ogUpcomingOrders && window.ogUpcomingOrders.results.length) {
          // user has a subscription
          isNextBoxMessageState = await window.toggleInNextBoxMessage(
            window.ogUpcomingOrders.results[0],
          )

          // setup modal to have subscription selected with correct modal options
          const subscribeRadioButton = document.querySelector('#subscribe')
          const oneTimeRadioButton = document.querySelector('#one-time')
          const subscribeOptions = document.querySelector('.subscribe-options')
          const oneTimeOptions = document.querySelector('.one-time-options')

          if (numberOfSellingPlans === '0') {
            // product is not subscribeable
            subscribeRadioButton.disabled = true
            subscribeRadioButton.checked = false
            subscribeOptions.classList.add('hide')
            oneTimeRadioButton.checked = true
            oneTimeOptions.classList.remove('hide')
          } else if (isNextBoxMessageState === 'shown') {
            // product is in the next box
            this.toggleSubscriptionSection('hide')
          } else {
            // product is subscribeable and not in the next box
            this.toggleSubscriptionSection('show')
            subscribeRadioButton.checked = true
            subscribeRadioButton.disabled = false
            oneTimeRadioButton.checked = false
            subscribeOptions.classList.remove('hide')
            oneTimeOptions.classList.add('hide')
          }
        } else {
          // user does not have a sub
          if (numberOfSellingPlans === '0') {
            // product is not subscribeable
            this.toggleSubscriptionSection('hide')
            return window.dispatchEvent(new CustomEvent("on-one-time-purchase"));
          } else {
            // product is subscribeable
            this.toggleSubscriptionSection('show')
          }

        }

        event.stopPropagation()
        window.dispatchEvent(new CustomEvent("open-modal"));
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}